import { Component, OnInit, Inject } from '@angular/core';
import { _ } from '@icc/shared/helpers';
import { PageComponent, SharedFacade, ICC_PAGE_DATA } from '@icc/configurator/shared';
import { IccFilling } from '@icc/window-door/types';

@Component({
    selector: 'icc-model-info',
    templateUrl: './model-info.component.html',
    styleUrls: ['./model-info.component.scss'],
    standalone: false
})
export class ModelInfoComponent extends PageComponent implements OnInit {
  public title = _('WINDOW|Podgląd modelu');
  public options = [];

  filling: IccFilling | null = null;
  fillingViewSide: 'inner' | 'outer';
  description: string | null = null;
  imageUrl = '';
  button = true;

  constructor(
      private sharedFacade: SharedFacade,
      @Inject(ICC_PAGE_DATA) private pageData: {
          filling: IccFilling,
          fillingViewSide?: 'inner' | 'outer',
          imageUrl?: string
      }
  ) {
      super();
  }

  ngOnInit() {
      const filling = this.pageData.filling;
      this.filling = filling;
      this.fillingViewSide = this.pageData.fillingViewSide;
      this.description = (filling as IccFilling & {description?: string | null}).description || null;
      this.imageUrl = this.pageData.imageUrl || '/files/filling/' + (
          this.fillingViewSide === 'inner' && filling.image_in
              ? filling.image_in
              : filling.image
      );
  }

  close() {
      this.sharedFacade.closePage(true);
  }

}
